module.exports = __webpack_public_path__ + "img/SR.5f2f5c83.svg";